import $ from 'jquery';
import $PromoCodes from '../../common/promo-codes';
import Quote from './Quote';
import SelectedJobsState from './SelectedJobsState';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  basket: '.js-basket',
  priceHeading: '.v2-basket-summary-title',
  totals: '.totals',
  ourPrice: '.our-price',
  dealerPrice: '.dealer-price',
  dealer: '.dealer',
  savings: '.savings',
  promotion: '.promotion',
  promoPrice: '.promo-price',
  dealerPriceLabel: '.js-basket-dealer-price-label',
};

export default class BasketSummary {
  constructor() {
    this.basket = $(SELECTORS.basket);
    this.priceHeading = $(SELECTORS.priceHeading);
    this.totals = this.basket.find(SELECTORS.totals);
    this.totalPrice = this.totals.find(SELECTORS.ourPrice).children('span');
    this.dealerPrice = this.totals.find(SELECTORS.dealerPrice).children('span');
    this.savingPercentage = this.totals.find(SELECTORS.savings).children('span');
    this.promotion = this.totals.find(SELECTORS.promotion);
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('quote:updated', (data) => this.update(data.quote));
  }

  update(data) {
    this._updatePriceHeading(data);
    this._updateDealerPrice(data);
    this._updateTotalPrice(data);
    this._updateSavings(data);
    this._updatePromotionalSaving(data);
  }

  renderPromoDiscount(discount) {
    this.promotion.removeClass('hidden').find(SELECTORS.promoPrice).text(discount);
  }

  _updatePriceHeading(data) {
    const quote = new Quote(data);
    this.priceHeading.text(quote.unquotedParts().length ? 'Partial price' : 'Total price');
  }

  _updateTotalPrice(data) {
    this.totalPrice.text(data['total_price']);
  }

  _updateDealerPrice(data) {
    const price = data['dealership_price'];
    if (price) {
      this.totals.find(`${SELECTORS.dealer}, ${SELECTORS.dealerPrice}`).removeClass('hidden');
      this.dealerPrice.text(price).data('dealership-price', price);
      this.totals.find(SELECTORS.dealerPriceLabel).text(new SelectedJobsState().ppiItemsOnly() ? 'The RAC price:' : 'Dealer price:');
    } else {
      this.totals.find(`${SELECTORS.dealer}, ${SELECTORS.dealerPrice}`).addClass('hidden');
    }
  }

  _updatePromotionalSaving(data) {
    if (data['promotional_saving']) {
      $PromoCodes.updateDynamicQuotePage(data);
    } else {
      this.promotion.addClass('hidden');
    }
  }

  _updateSavings(data) {
    const saving = data['saving'];
    if (saving) {
      this.totals.find(SELECTORS.savings).removeClass('hidden');
      this.totals.find(this.savingPercentage).text(saving);
    } else {
      this.totals.find(SELECTORS.savings).addClass('hidden');
    }
  }
}
